export default __webpack_public_path__ + "static/media/instagram.981e68a1.svg";